import { FileReader, FileWriter } from '@/platform'
import Viewport from '../ComControl/Viewport'
import FileName from '../ComControl/FileName'
import AvgButtonIndex from '../ComControl/AvgButtonIndex'
import GoodPropertyModel from '../GoodPropertyModel'
import FontProperty from '../MallNewClass/FontProperty'

class GoodsLimite {
    public static LimitGoodsType = {
        Var: 2,
        Dress: 4
    }
    public static LimitTypeEnum = {
        /**限时商品 */
        Time: 1,
        /**限量商品 */
        Count: 2
    }
    public GoodsId: number = 1001 // 商品ID
    public GoodsName: string = '限时商品' // 商品名称
    public GoodsFont: FontProperty = new FontProperty() // 商品名称文字属性
    public GoodsName_X: number = 0 // 商品名称的X坐标
    public GoodsName_Y: number = 0 // 商品名称的Y坐标
    public GoodsPrice: number = 10 // 商品价格
    public GoodsPricePakoras: number = 0 // 商品价格丸子
    public GoodsPriceFont: FontProperty = new FontProperty() // 商品价格文字属性
    public GoodsPrice_X: number = 0 // 商品价格X坐标
    public GoodsPrice_Y: number = 0 // 商品价格Y坐标
    public GoodsIntro: string = '商品简介' // 商品信息
    public GoodsIntroFont: FontProperty = new FontProperty() // 商品简介文字属性
    public GoodsIntroView: Viewport = new Viewport(0, 0, 200, 50) // 商品简介视窗信息

    // 商品窗格底板
    public GoodsBack: FileName = new FileName({ type: FileName.DEF_TYPE, name: '商城\\商城_商品底板.png' })

    public GoodsBack_X: number = 0 // 商品窗格底板X坐标
    public GoodsBack_Y: number = 0 // 商品窗格底板Y坐标
    public GoodsBack_W: number = 1 // 商品窗格底板宽度
    public GoodsBack_H: number = 1 // 商品窗格底板高度

    // 预览图
    public Preview: FileName = new FileName({ type: FileName.DEF_TYPE, name: '商品图片_属性优化.png' })

    public Preview_X: number = 0 // 预览图X坐标
    public Preview_Y: number = 0 // 预览图Y坐标
    public Preview_W: number = 1 // 预览图宽度
    public Preview_H: number = 1 //预览图高度

    // 预览图
    public PreviewBack: FileName = new FileName({ type: FileName.DEF_TYPE, name: '商城\\商城_商品背景图.png' })

    public PreviewBack_X: number = 0 // 预览图底图X坐标
    public PreviewBack_Y: number = 0 // 预览图底图Y坐标
    public PreviewBack_W: number = 1 // 预览图底图宽度
    public PreviewBack_H: number = 1 // 预览图底图高度
    public Flower_X: number = 0 // 鲜花X坐标
    public Flower_Y: number = 0 // 鲜花Y坐标
    public BuyBtn: AvgButtonIndex = new AvgButtonIndex(42, 0, 0) // 购买按钮

    // 已购买图片
    public BoughtBtn: FileName = new FileName({ type: FileName.DEF_TYPE, name: '商城\\商城_已购买.png' })

    public CanBuyRepeat: boolean = false // 是否可以重复购买
    public GoodsProperty: string = '' // 商品属性
    public PropertyList: Array<GoodPropertyModel> = [] // 商品属性
    public ExpandStr: string = '' // 扩展字段
    public UpMallTime: number = 0 // 商品上架时间(时间戳)
    public DownMallTime: number = 0 // 商品下架时间(时间戳)

    private _SaleDays = 30 // 售卖天数

    get SaleDays() {
        return this._SaleDays
    }
    set SaleDays(val: number) {
        this._SaleDays = val
        this.DownMallTime = this.UpMallTime + this._SaleDays * 86400
    }

    constructor(FontColor_UI: string = '255,255,255') {
        this.GoodsFont = new FontProperty('微软雅黑', 21, FontColor_UI)
        this.GoodsPriceFont = new FontProperty('微软雅黑', 18, FontColor_UI)
        this.GoodsIntroFont = new FontProperty('微软雅黑', 18, FontColor_UI)
        this.GoodsSales = new FontProperty('微软雅黑', 21, FontColor_UI)
    }

    public GoodsSales: FontProperty = new FontProperty() // 售卖情况
    public SalesX: number = 0 // 售卖情况X坐标
    public SalesY: number = 0 // 售卖情况Y坐标
    public CountX: number = 0 // 售卖数量X坐标
    public CountY: number = 0 // 售卖数量Y坐标

    /**商品类型 2=数值 4=装饰 */
    public GoodType = GoodsLimite.LimitGoodsType.Var

    /**商品限购类型 1=限时 2=限量 */
    public LimitType = GoodsLimite.LimitTypeEnum.Time

    /**商品数量 */
    public GoodLimitCount = 50

    readVersionedOui(reader: FileReader) {
        this.GoodsId = reader.readInt()
        this.GoodsBack_X = reader.readInt()
        this.GoodsBack_Y = reader.readInt()

        this.GoodsName = reader.readString()
        this.GoodsFont.readVersionedOui(reader.readObj(reader.readInt()))
        this.GoodsName_X = reader.readInt()
        this.GoodsName_Y = reader.readInt()

        this.GoodsPrice = reader.readInt()
        this.GoodsPriceFont.readVersionedOui(reader.readObj(reader.readInt()))
        this.GoodsPrice_X = reader.readInt()
        this.GoodsPrice_Y = reader.readInt()

        this.GoodsIntro = reader.readString()
        this.GoodsIntroFont.readVersionedOui(reader.readObj(reader.readInt()))
        this.GoodsIntroView.readVersionedOui(reader.readObj(reader.readInt()))

        this.GoodsBack.readVersionedOui(reader.readObj(reader.readInt()))
        this.GoodsBack_W = reader.readInt()
        this.GoodsBack_H = reader.readInt()

        this.Preview.readVersionedOui(reader.readObj(reader.readInt()))
        this.Preview_X = reader.readInt()
        this.Preview_Y = reader.readInt()
        this.Preview_W = reader.readInt()
        this.Preview_H = reader.readInt()

        this.PreviewBack.readVersionedOui(reader.readObj(reader.readInt()))
        this.PreviewBack_X = reader.readInt()
        this.PreviewBack_Y = reader.readInt()
        this.PreviewBack_W = reader.readInt()
        this.PreviewBack_H = reader.readInt()

        this.Flower_X = reader.readInt()
        this.Flower_Y = reader.readInt()

        this.BuyBtn.readVersionedOui(reader.readObj(reader.readInt()))
        this.BoughtBtn.readVersionedOui(reader.readObj(reader.readInt()))

        this.CanBuyRepeat = Boolean(reader.readInt())
        this.GoodsProperty = reader.readString()
        this.UpMallTime = reader.readLong()
        this.DownMallTime = reader.readLong()

        this._SaleDays = (this.DownMallTime - this.UpMallTime) / 86400

        this.GoodsSales.readVersionedOui(reader.readObj(reader.readInt()))

        this.SalesX = reader.readInt()
        this.SalesY = reader.readInt()

        const count = reader.readInt()
        if (count > 0) {
            for (let index = 0; index < count; index++) {
                const goodsProperty = new GoodPropertyModel()
                goodsProperty.readVersionedOui(reader.readObj(reader.readInt()))
                this.PropertyList.push(goodsProperty)
            }
        }

        if (!reader.isReadEnd()) {
            this.CountX = reader.readInt()
            this.CountY = reader.readInt()
        }

        try {
            this.GoodType = reader.readInt()
            this.LimitType = reader.readInt()
            this.GoodLimitCount = reader.readInt()
        } catch (error) {
            /*  */
        }
    }

    writeVersionedOui(writer: FileWriter): void {
        writer.writerIntLength()

        writer.writeInt(this.GoodsId)
        writer.writeInt(this.GoodsBack_X)
        writer.writeInt(this.GoodsBack_Y)
        writer.writeString(this.GoodsName)

        this.GoodsFont.writeVersionedOui(writer)

        writer.writeInt(this.GoodsName_X)
        writer.writeInt(this.GoodsName_Y)
        writer.writeInt(this.GoodsPrice)

        this.GoodsPriceFont.writeVersionedOui(writer)

        writer.writeInt(this.GoodsPrice_X)
        writer.writeInt(this.GoodsPrice_Y)
        writer.writeString(this.GoodsIntro)

        this.GoodsIntroFont.writeVersionedOui(writer)
        this.GoodsIntroView.writeVersionedOui(writer)
        this.GoodsBack.writeVersionedOui(writer)

        writer.writeInt(this.GoodsBack_W)
        writer.writeInt(this.GoodsBack_H)

        this.Preview.writeVersionedOui(writer)

        writer.writeInt(this.Preview_X)
        writer.writeInt(this.Preview_Y)
        writer.writeInt(this.Preview_W)
        writer.writeInt(this.Preview_H)

        this.PreviewBack.writeVersionedOui(writer)

        writer.writeInt(this.PreviewBack_X)
        writer.writeInt(this.PreviewBack_Y)
        writer.writeInt(this.PreviewBack_W)
        writer.writeInt(this.PreviewBack_H)

        writer.writeInt(this.Flower_X)
        writer.writeInt(this.Flower_Y)

        this.BuyBtn.writeVersionedOui(writer)
        this.BoughtBtn.writeVersionedOui(writer)

        writer.writeInt(this.CanBuyRepeat ? 1 : 0)
        writer.writeString(this.GoodsProperty)
        writer.writeInt64(this.UpMallTime)
        writer.writeInt64(this.DownMallTime)

        this.GoodsSales.writeVersionedOui(writer)

        writer.writeInt(this.SalesX)
        writer.writeInt(this.SalesY)

        if (this.PropertyList.length > 0) {
            writer.writeInt(this.PropertyList.length)
            for (let i = 0; i < this.PropertyList.length; i++) {
                const property = this.PropertyList[i]
                property.writeVersionedOui(writer)
            }
        } else {
            writer.writeInt(0)
        }

        writer.writeInt(this.CountX)
        writer.writeInt(this.CountY)

        writer.writeInt(this.GoodType)
        writer.writeInt(this.LimitType)
        writer.writeInt(this.GoodLimitCount)

        writer.writerLength()
    }
}
export default GoodsLimite
